import { Environment } from './environment.model';

export const ENVIRONMENT_STG: Environment = {
  production: false,
  name: 'stg',
  staticFilesHost: 'https://static.stg.twaice.ai/',
  baseUrlApi: 'https://api.stg.twaice.ai/',
  pshEmbedUrl: 'https://psh.stg.twaice.cloud/psh/login',
  // public identifier for the Transifex project
  transifexToken: '1/e60edf51d3cbc5c2a847caef792f9da32ba18ef6',
  // public HubSpot Portal ID
  hubspotPortalId: '25492978',
  // public Mixpanel ID
  mixpanelId: '4f213a56d72f86ef826d5cc8b1ed19e9',
};
